import React, { useEffect, useState } from "react";
import "./OtpForm.scss";
import { Flex, Input } from "antd";

interface IOtpForm {
  submit: (email: string, otp: string) => void;
  email: string;
  isError: boolean;
  setIsError: (isError: boolean) => void;
  handleResendOTP: (email: string) => void;
}

const OtpForm: React.FC<IOtpForm> = ({
  submit,
  email,
  isError,
  setIsError,
  handleResendOTP,
}) => {
  const [targetEmail, setTargetEmail] = useState<any>(email);
  const urlParams = new URLSearchParams(window.location.search);
  const [isWaitToResendOtp, setIsWaitToResendOtp] = useState(false);
  const [timeLeft, setTimeLeft] = useState(30);
  const emailParam = urlParams.get("targetEmail");

  const handleChangeOTP = (otp: string) => {
    submit(targetEmail, otp);
  };

  useEffect(() => {
    if (emailParam) {
      setTargetEmail(emailParam!);
      handleResendOTP(emailParam!);
    }
  }, [emailParam]);

  const runCountdown = () => {
    const timer = setInterval(() => {
      setTimeLeft((prevTime) => prevTime - 1);
    }, 1000);

    setTimeout(() => {
      clearInterval(timer);
      setIsWaitToResendOtp(false);
      setTimeLeft(30);
    }, 30000);
  };

  const formatTime = (seconds: number) => {
    const minutes = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${minutes}:${secs < 10 ? "0" : ""}${secs}`;
  };

  return (
    <div className="OtpForm">
      <div className="message">
        <div className="title">
          Please enter the one time password to verify your account
        </div>
        <div className="sub-title">
          A code has been sent to *****{targetEmail?.slice(-12)}. Your OTP code
          is valid for 5 minnutes
        </div>
      </div>
      <Flex gap="middle" align="center" vertical>
        <Input.OTP
          status={isError ? "error" : ""}
          variant="filled"
          onChange={handleChangeOTP}
          autoFocus
          onInput={() => setIsError(false)}
        />
      </Flex>
      <div className="resend-btn">
        You haven't recieved OTP code yet?{" "}
        <span
          className={isWaitToResendOtp ? "wait" : ""}
          onClick={() => {
            if (!isWaitToResendOtp) {
              setIsWaitToResendOtp(true);
              handleResendOTP(targetEmail!);
              runCountdown();
            }
          }}
        >
          Resend
        </span>
        <span className={`time-countdown ${isWaitToResendOtp ? "" : "hide"}`}>
          ({formatTime(timeLeft)})
        </span>
      </div>
    </div>
  );
};

export default OtpForm;
